import advance from './advance/index';
import artist from './artist';
import clientAccount from './client-account';
import clientUser from './client-user-management';
import contract from './contract';
import cost from './cost';
import digitalDelivery from './digital-delivery';
import event from './event';
import eventCashFlow from './event-cash-flow';
import income from './income';
import label from './label';
import merch from './merch';
import musicProductDigital from './music-product-digital';
import musicProductPhysical from './music-product-physical';
import provider from './providers';
import saleChannel from './sale-channel/index';
import settings from './settings';
import template from './templates';
import track from './track';
import user from './user-management';
import video from './video';

export default {
  track,
  video,
  musicProductDigital,
  musicProductPhysical,
  artist,
  user,
  clientUser,
  label,
  contract,
  template,
  saleChannel,
  merch,
  cost,
  income,
  provider,
  advance,
  settings,
  digitalDelivery,
  clientAccount,
  event,
  eventCashFlow,
};
